import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class CustomerSiteCostAndContractService {

  public _CustomerSiteCostAndContract = environment.CustomerSiteCostAndContract;
  public _httpOptions;
  public sessionId : string
  constructor(private http: HttpClient) {
    this.sessionId = sessionStorage["SessionId"]
    this._httpOptions = {
      headers: new HttpHeaders({ 'SessionId':this.sessionId })
    };
  
   }

  CustomerSiteCostAndContractServiceInit() {
   
    var Query = this._CustomerSiteCostAndContract ;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions).pipe(map(data => {
      const resultJSON = JSON.parse(JSON.stringify(data));
      // console.log(resultJSON);        
      return data;
    }));
  }

  create(Contract: FormData) {
    var Query = this._CustomerSiteCostAndContract;
    return this.http.post<{ data: any }>(Query, Contract,this._httpOptions);
  }

  edit(Contract: FormData)
  {     
    var Query = this._CustomerSiteCostAndContract;
    // console.log(Query);
    return this.http.put<{data:any}>(Query,Contract,this._httpOptions);
  }

  GetById(customerSiteId:string): Observable<any>{
    var Query = this._CustomerSiteCostAndContract + '/GetById' +'/'+ customerSiteId ;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }

  GetDistance(frombranch:string): Observable<any>{
    var Query = this._CustomerSiteCostAndContract + '/GetDistance' +'/'+ frombranch;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }

  GetDistanceRegion(frombranch:string,toRegionCode:string): Observable<any>{
    var Query = this._CustomerSiteCostAndContract + '/GetDistanceRegion' +'/'+ frombranch +'/'+ toRegionCode;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  
  
  GetDistanceFromAndToBranch(frombranch:string, toBranchCode:string): Observable<any>{
    var Query = this._CustomerSiteCostAndContract + '/GetDistanceFromAndToBranch' +'/'+ frombranch +'/'+ toBranchCode;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }

  excelUpload(Contract: FormData) {
    var Query = this._CustomerSiteCostAndContract +'/ExcelUpload';
    return this.http.post<{ data: any }>(Query, Contract,this._httpOptions);
  }
  
}
